<script setup lang="ts">
import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {CasesSuspendedAnalyticProps} from "@/types/analytics";

defineProps<CasesSuspendedAnalyticProps>();
</script>

<template>
  <div class="params">
    <div class="params__wrapper">
      <StatBlock
        title="приостановлено дел по п.п.1,2,3 ч.1 ст. 208 УПК РФ"
        :value="analyticData.totalData?.suspended_cases?.value"
        :percent="analyticData.totalData?.suspended_cases?.percent_to_previous"
        :is-appg="false"
        :is-main="true"
      />
      <StatBlock
        title="удельный вес от расследованных"
        :value="analyticData.totalData?.suspended_cases_percent?.value"
        :percent="analyticData.totalData?.suspended_cases_percent?.percent_to_previous"
        :is-appg="true"
      />
    </div>

    <DynamicByMonth
      :active-type="activeType"
      :selected-region="selectedRegion"
      :selected-district="selectedDistrict"
      :dynamic="analyticData.monthlyDynamic"
    />
    <template v-if="activeType !== 'region'">
      <RegionTop
        sort-order="desc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topDescending"
      />
      <RegionTop
        sort-order="asc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topAscending"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.params {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    margin-top: auto;
  }
}
</style>